<template>
  <div class="page-container">
    <div class="main">
      <page
          ref="pageRef"
          :url="url"
          :form="form"
          :columns="columns"
          :sort-info="sortInfo"
          @reset="reset"
          @sortedFormatter="sortedFormatter"
      >
        <template slot="tableSearch">
          <el-form-item
              :label="$t('text.paymentChannel')"
          >
            <el-select v-model="form.channelId" filterable clearable :placeholder="$t('message.chooseOne')">
              <el-option :label="$t('option.all')" value=""></el-option>
              <el-option
                  v-for="item in payOption"
                  :key="item.channelId"
                  :label="item.channelId + ' - ' + item.channelName"
                  :value="item.channelId"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('text.upstream')" label-width=100px>
            <el-select v-model="form.upstream" filterable clearable :placeholder="$t('message.chooseOne')">
              <el-option :label="$t('option.all')" value=""></el-option>
              <el-option v-for="item in upstreamList"
                         :key="item.code"
                         :label="item.displayName"
                         :value="item.code"/>
            </el-select>
          </el-form-item>

          <el-form-item
              :label="$t('text.channelType')"
              prop="productId"
          >
            <el-select
                v-model="form.productId"
                filterable
                :placeholder="$t('message.chooseOne')"
            >
              <el-option :label="$t('option.all')" value=""></el-option>
              <el-option :label="$t('text.collection')" :value="PAYMENT_TYPE_ID_COLLECTION()"/>
              <el-option :label="$t('text.disbursement')" :value="PAYMENT_TYPE_ID_PAYMENT()"/>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('text.channelAgentName')" label-width=100px>
            <el-select v-model="form.channelAgentId" filterable clearable :placeholder="$t('message.chooseOne')">
              <el-option :label="$t('option.all')" value=""></el-option>
              <el-option v-for="agent in agentList"
                         :key="agent.agentId"
                         :label="agent.agentName"
                         :value="agent.agentId"/>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('text.date')">
            <el-date-picker
                v-model="timeDate"
                type="daterange"
                format="yyyy-MM-dd"
                value-format="yyyyMMdd"
                :range-separator="$t('text.to')"
                :start-placeholder="$t('text.startDate')"
                :end-placeholder="$t('text.endDate')"
                @change="timeChange"
            >
            </el-date-picker>

          </el-form-item>
        </template>

        <template slot="buttonArea">

          <el-button :loading="loading" type="primary" @click="generateStatisticsToday" size="small">
            {{ $t('text.refreshToday') }}
          </el-button>

          <el-button :loading="loading"
                     :disabled="exporting"
                     type="primary"
                     @click="exportDetail"
                     size="small">
            {{ $t('text.export') }}
          </el-button>

          <el-button :loading="loading"
                     :disabled="exporting"
                     type="primary"
                     @click="exportAgentDetail"
                     size="small">
            {{ $t('text.agentChannelExport') }}
          </el-button>
        </template>

        <template slot="tableSlotScope" slot-scope="{ row, column }">
          <template v-if="column.prop === 'operate'">
            <el-button type="primary"
                       plain size="mini"
                       @click="showDetails(row)">
              {{ $t('text.channelDetails') }}
            </el-button>
          </template>
        </template>
      </page>
      <StatisticsChannelDetails :show.sync="openDetails" :value="formData" :titleChannelName="titleChannelName"/>
    </div>
  </div>
</template>
<script>
import Page from "@/components/Page.vue";
import moment from "moment";
import StatisticsChannelDetails from "@/views/route/StatisticsChannelDetails.vue";
import {PAYMENT_TYPE_ID_COLLECTION, PAYMENT_TYPE_ID_PAYMENT} from "@/utils/Constant";

export default {
  components: {
    page: Page,
    StatisticsChannelDetails: StatisticsChannelDetails,
  },
  data() {
    return {
      url: "/statistics-channel/listStatistics",
      payOption: [],
      loading: false,
      exporting: false,
      action: "",
      titleChannelName: "",
      openDetails: false,
      sortStates: {
        totalAmount: "ascending",
        transactionCount: null,
      },
      sortInfo: {prop: 'amount', order: 'ascending'},
      columns: [
        {
          prop: 'statisticsDate',
          label: 'text.date',
          width: 100,
          align: 'center',
          fixed: true,
          formatter: this.$formatter.formatDate
        },
        {prop: 'channelId', label: 'text.channelId', width: 80, align: 'center', fixed: true},
        {prop: 'channelName', label: 'text.channelName', width: 150, align: 'center', fixed: true},
        {
          prop: 'updateTimeL',
          label: 'text.updateTime',
          width: 150,
          align: 'center',
          formatter: this.$formatter.formatDate
        },
        {prop: 'upstream', label: 'text.upstream', width: 150, align: 'center'},
        {prop: 'payType', label: 'text.channelType', width: 80, align: 'center'},

        {prop: '__sep1', label: '|', width: 20, align: 'center', formatter: () => '|'},

        {
          prop: 'totalAmount',
          label: 'text.transactionAmount',
          width: 140,
          align: 'center',
          formatter: this.$formatter.FenToYuanToThousandth,
          sortable: 'custom'
        },
        {prop: 'paymentCount', label: 'text.transactionCount', width: 100, align: 'center'},
        {prop: 'paymentCountSuccess', label: 'text.transactionSuccessCount', width: 120, align: 'center'},
        {
          prop: 'paymentCountSuccessRate',
          label: 'text.transactionSuccessRate',
          width: 130,
          align: 'center',
          sortable: 'custom',
          style: (row) => this.getTextStyle(row.payType, row.paymentCountSuccessRate)
        },

        {prop: '__sep2', label: '|', width: 20, align: 'center', formatter: () => '|'},

        {prop: 'iftFeeRate', label: 'text.iftFeeRate', width: 70, align: 'center'},
        {
          prop: 'iftAmount',
          label: 'text.iftAmount',
          width: 140,
          align: 'center',
          formatter: this.$formatter.FenToYuanToThousandth
        },
        {prop: 'ibftFeeRate', label: 'text.ibftFeeRate', width: 90, align: 'center'},
        {
          prop: 'ibftAmount',
          label: 'text.ibftAmount',
          width: 140,
          align: 'center',
          formatter: this.$formatter.FenToYuanToThousandth
        },

        {prop: '__sep3', label: '|', width: 20, align: 'center', formatter: () => '|'},

        {prop: 'channelAgentName', label: 'text.channelAgentName', width: 160, align: 'center'},
        {prop: 'channelAgentRate', label: 'text.channelAgentRate', width: 110, align: 'center'},
        {
          prop: 'channelAgentFee',
          label: 'text.channelAgentFee',
          width: 140,
          align: 'center',
          formatter: this.$formatter.FenToYuanToThousandth
        },

        {prop: '__sep4', label: '|', width: 20, align: 'center', formatter: () => '|'},

        {
          prop: 'paymentFee',
          label: 'text.channelCost',
          width: 140,
          align: 'center',
          formatter: this.$formatter.FenToYuanToThousandth
        },
        {
          prop: 'merFee',
          label: 'text.merchantFee',
          width: 140,
          align: 'center',
          formatter: this.$formatter.FenToYuanToThousandth
        },
        {
          prop: 'calBalance',
          label: 'text.profit',
          width: 140,
          align: 'center',
          formatter: this.$formatter.FenToYuanToThousandth
        },
        {
          prop: 'realBalance',
          label: 'text.actualAmount',
          width: 140,
          align: 'center',
          formatter: this.$formatter.FenToYuanToThousandth
        },
        {prop: 'realBalanceTime', label: 'text.balanceUpdateTime', width: 160, align: 'center'},
        {
          prop: 'quota',
          label: 'text.quota',
          width: 140,
          align: 'center',
          formatter: this.$formatter.FenToYuanToThousandth
        },
        {prop: 'quotaUsageRate', label: 'text.quotaUsageRate', width: 100, align: 'center'},

        {prop: 'operate', label: 'text.actions', width: 110, align: 'center', fixed: 'right'},
      ],

      formData: [],
      list: [],
      form: {
        startDate: moment().subtract(0, 'days').format('yyyyMMDD'),
        endDate: moment().format('yyyyMMDD'),
      },
      timeDate: [moment().subtract(0, 'days').format('yyyyMMDD'), moment().format('yyyyMMDD')],
      totalList: [],
      upstreamList: [],
      agentList: [],
    };
  },
  methods: {
    PAYMENT_TYPE_ID_PAYMENT() {
      return PAYMENT_TYPE_ID_PAYMENT
    },
    PAYMENT_TYPE_ID_COLLECTION() {
      return PAYMENT_TYPE_ID_COLLECTION
    },
    timeChange(e) {
      if (e) {
        this.form.startDate = e[0];
        this.form.endDate = e[1];
      } else {
        this.form.startDate = "";
        this.form.endDate = "";
      }
    },
    reset() {
      let start = moment().subtract(7, 'days').format('yyyyMMDD');
      let end = moment().format('yyyyMMDD');
      this.form.startDate = start;
      this.form.endDate = end;
      this.timeDate = [start, end];
    },

    generateStatisticsToday() {
      this.$axios.get('/statistics-channel/generateStatisticsToday', {params: {}})
          .then(res => {
            if (res.code === 200) {
              this.$notify({
                title: this.$t('text.prompt'),
                message: res.msg,
                type: 'success',
              })

              this.$bus.$emit('refresh') //通知刷新
            } else {
              this.$notify.error({
                title: this.$t('text.prompt'),
                message: res.msg,
              })
            }
          })
    },
    exportDetail() {
      this.loading = true;
      this.exporting = true;
      this.axios
          .get("/statistics-channel/list-statistics/export", {
            params: this.form,
            responseType: "blob",
            timeout: 30 * 60 * 1000
          })
          .then((res) => {
            if (res.data) {
              // 回excel資料，瀏覽器下載
              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", this.$t('text.channelReportExport'));
              document.body.appendChild(link);
              link.click();
            } else if (res.text) {
              // 回JSON，開彈窗
              res.text()
                  .then(JSON.parse)
                  .then((res) => {
                    if (res.code !== 200) {
                      this.$message({
                        message: res.msg,
                        type: "error"
                      });
                    } else {
                      this.$message({
                        message: res.msg,
                        type: "success"
                      });
                    }
                  });
            }
            this.exporting = false;
          }).catch((error) => {
        this.$notify.error({
          title: this.$t('text.prompt'),
          message: this.$t('message.exportFailed')
        });
        this.exporting = false;
      });
      this.loading = false;
    },
    exportAgentDetail() {
      this.loading = true;
      this.exporting = true;
      this.axios
          .get("/statistics-channel/list-statistics/agent/export", {
            params: this.form,
            responseType: "blob",
            timeout: 30 * 60 * 1000
          })
          .then((res) => {
            if (res.data) {
              // 回excel資料，瀏覽器下載
              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", this.$t('text.agentChannelExportExcel'));
              document.body.appendChild(link);
              link.click();
            } else if (res.text) {
              // 回JSON，開彈窗
              res.text()
                  .then(JSON.parse)
                  .then((res) => {
                    if (res.code !== 200) {
                      this.$message({
                        message: res.msg,
                        type: "error"
                      });
                    } else {
                      this.$message({
                        message: res.msg,
                        type: "success"
                      });
                    }
                  });
            }
            this.exporting = false;
          }).catch((error) => {
        this.$notify.error({
          title: this.$t('text.prompt'),
          message: this.$t('message.exportFailed')
        });
        this.exporting = false;
      });
      this.loading = false;
    },
    showDetails(row) {
      this.formData = [...row.statisticsChannelInfoDetails, row];
      this.titleChannelName = row.statisticsDate + " - " + row.channelId + " - " + row.channelName;
      this.openDetails = true;
    },
    getTextStyle(type, value) {
      if (Number(type) === 110) {
        if (value < 0.5) {
          return {color: 'red'};
        } else if (value >= 0.5 && value < 0.6) {
          return {color: 'orange'};
        }
      } else if (Number(type) === 120 && value < 0.85) {
        return {color: 'red'};
      }
      return {};
    },
    sortedFormatter(sortEvent) {
      const { prop, order } = sortEvent || {};
      if (!prop) return;

      const toNumber = (val) => {
        if (val === null || val === undefined || val === '') return 0;
        const s = val.toString().trim().replace(/,/g, '').replace(/%$/, '');
        const n = Number(s);
        return Number.isNaN(n) ? 0 : n;
      };

      const comparator = (a, b) => {
        const aVal = toNumber(a[prop]);
        const bVal = toNumber(b[prop]);

        const aZero = aVal === 0;
        const bZero = bVal === 0;

        if (aZero && !bZero) return 1;
        if (!aZero && bZero) return -1;
        if (aZero && bZero) return 0;

        return order === 'ascending' ? aVal - bVal : bVal - aVal;
      };

      const targetCol = this.columns.find(c => c.prop === prop);
      if (!targetCol) return;

      if (targetCol.sortable === 'custom') {
        if (!order) return;
        if (this.$refs.pageRef && Array.isArray(this.$refs.pageRef.list)) {
          this.$refs.pageRef.list = [...this.$refs.pageRef.list].sort(comparator);
        }
        return;
      }

      targetCol.sortMethod = order ? comparator : undefined;
    },
  },
  created() {
    this.$axios
        .get('/routeChannelInfo/selectByCondition', {params: {}})
        .then(res => {
          res.data.map(item => {
            this.payOption.push(item)
          })
        });
    this.$axios
        .get("/order/orderPayment/selectPackagedUpstream", {params: {}})
        .then((res) => {
          this.upstreamList = res.data;
        });
    this.$axios
        .get("/channelAgent/list", {params: {}})
        .then((res) => {
          this.agentList = res.data;
        });
  },
};
</script>
<style lang="scss" scoped>

</style>
